(function($) {
  'use strict';

  // FeeBee fees should be displayed at the bottom visually, while Shopify keeps
  // the original cart line order for quantity and remove actions.
  function moveFeeBeeFeesToBottom() {
    $('.thb-cart-form tbody').each(function() {
      var $tableBody = $(this);
      var $feeRows = $tableBody.children('tr.main_cart[data-feebee-fee="true"]');

      if ($feeRows.length) {
        $tableBody.append($feeRows);
      }
    });

    $('#side-cart .mini-cart.cart_list.product_list_widget').each(function() {
      var $list = $(this);
      var $feeItems = $list.children('.mini_cart_item[data-feebee-fee="true"]');

      if ($feeItems.length) {
        $list.append($feeItems);
      }
    });
  }

  $(moveFeeBeeFeesToBottom);
  $(document).ajaxComplete(moveFeeBeeFeesToBottom);
})(jQuery);
